import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface IDesktopItem {
    isActive: boolean;
    isSelected: boolean;
}

export const StyledDesktopItem = styled.li<IDesktopItem>`
    cursor: pointer;
    display: block;
    position: relative;
    padding-left: 13px;
    font-size: 14px;
    border: none;
    text-align: left;
    line-height: 32px;
    color: ${(props) => props.theme.shades.blackGrey};
    ${(props) =>
        props.isActive
            ? css`
                  background: ${props.theme.colors['main8']};
                  color: ${props.theme.shades.white};
              `
            : ``}
    ${(props) =>
        !props.isActive && props.isSelected
            ? css`
                  background: ${props.theme.shades.lightGrey};
              `
            : ``}
`;

export const StyledHeaderItem = styled(StyledDesktopItem)`
    font-weight: 700;
    line-height: 40px;
`;

export const StyledSubHeaderItem = styled(StyledDesktopItem)`
    font-weight: 700;
    cursor: default;
    margin-top: 5px;
`;

export const StyledDesktopMenu = styled.ul`
    position: absolute;
    background-color: ${(props) => props.theme.shades.white};
    width: 100%;
    padding: 0;
    max-height: 265px;
    overflow: auto;
    z-index: 2;
    box-shadow: 0px 4px 6px -3px rgba(0, 0, 0, 0.7);
    ${(props: { menuOpen: boolean }) =>
        !props.menuOpen &&
        css`
            height: 0;
        `}
`;

export const DividerLine = styled.span`
    height: 1px;
    width: 100%;
    background-color: ${(props) => props.theme.shades.lightMidGrey};
    margin: 0 13px;
    display: inline-block;
    z-index: 3;

    /* IE11 fix */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        display: block;
        margin: 0;
    }
`;
